export const mutations = {
  setAtividadeOs(state, payload) {
    state.atividadeOs = { ...payload };
  },
  setAtividadesOs(state, payload) {
    state.atividadesOs = payload;
  },
  setModalCadastroAtividadeOs(state, payload) {
    state.modalCadastroAtividadeOs = payload;
  },
  removeAtividadeOs(state, data) {
    let index = state.atividadesOs.map((x) => x.id).indexOf(data.id);
    state.atividadesOs.splice(index, 1);
  },
  setModalExcluirAtividadeOs(state, payload) {
    state.modalExcluirAtividadeOs = payload;
  },
  setModalHistoricoStatusOS(state, payload) {
    state.modalHistoricoStatusOS = payload;
  },
};

export default {};
